import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ApiResponse } from "@client/types/Api";
import { type ReduxAction } from "@client/types/ReduxAction";
import {
  Actions,
  type GoToStepActionData,
  type InitSuccessActionData,
  type ProceedAlertActionData,
  type SetErrorActionData,
  type SetupSuccessActionData,
  type SystemAssignFailedActionData,
  type UserVerifiedActionData
} from "./actions";
import { type Purchase } from "./types";

export type SetupData = Purchase.Api.AssignSystemResponse;

const reducer = (state: Purchase.AppState, action: ReduxAction<any>): Purchase.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const data = action.data as InitSuccessActionData;
      return {
        ...state,
        ...data,
        status: Status.Ready,
        step: data.package && data.payment ? 1 : 0
      };
    }
    case Actions.GoToStep: {
      const { step } = action.data as GoToStepActionData;
      if (step === 1) return { ...defaultState, id: state.id };

      return {
        ...state,
        step
      };
    }
    case Actions.UserVerified: {
      const data = action.data as UserVerifiedActionData;
      return {
        ...state,
        alert: data.alert || null,
        error: null,
        firstStepData: data.data,
        step: data.alert ? 1 : 2,
        verfiyResult: data.result
      };
    }
    case Actions.SystemAssignFailed: {
      const { error } = action.data as SystemAssignFailedActionData;
      return {
        ...state,
        error,
        step: 3
      };
    }

    case Actions.SetupBegin: {
      return {
        ...state,
        step: 3,
        error: null,
        isSettingUp: true
      };
    }
    case Actions.SetupFailure: {
      const { error } = action.data as ApiResponse<any>;
      return {
        ...state,
        error: error as Purchase.Api.ErrorCode,
        isSettingUp: false
      };
    }
    case Actions.SetupSuccess: {
      const { redirectUrl } = action.data as SetupSuccessActionData;
      return {
        ...state,
        error: null,
        isSettingUp: false,
        redirectUrl
      };
    }
    case Actions.ProceedAlert: {
      const { proceed } = action.data as ProceedAlertActionData;
      return {
        ...state,
        alert: null,
        step: proceed ? state.step + 1 : state.step
      };
    }
    case Actions.SetError: {
      const { error } = action.data as SetErrorActionData;
      return {
        ...state,
        error
      };
    }
    default:
      return state;
  }
};

export const defaultState: Purchase.AppState = {
  id: "",
  alert: null,
  error: null,
  firstStepData: null,
  isSettingUp: false,
  package: null,
  payment: null,
  redirectUrl: "",
  status: Status.None,
  step: 0,
  trial: null,
  verfiyResult: null
};
export const previewState: Purchase.AppState = {
  ...defaultState,
  status: Status.Ready,
  step: 1
};
export default wrapReducer({ defaultState, reducer, previewState });
